import React from 'react'
import { Paragraph } from '../components/paragraph/Paragraph'

export function Translation() {
  return (
    <React.Fragment>
      <Paragraph>
        My main activity and passion is Italian>English translation.
      </Paragraph>
      <Paragraph>
        I strive to produce fluid, consistent and accurate translations, working with various Computer Assisted Translation tools to enhance my working capacity.
      </Paragraph>
      <Paragraph>
        I am sensitive to various registers and always seek to transfer the tone, style and cultural specifics of a text. I pay attention to minute details in the source in order to faithfully convey the content. At the same time, I am able to detract from the syntax of the original and focus on the meaning as a whole. This ensures my translations are never stilted but comprehensible and fluid, without compromising on accuracy.
      </Paragraph>
      <Paragraph>
        I enjoy carrying out in-depth research into various topics and familiarising myself with the client’s business in order to ensure every word of the translation is the right one.
      </Paragraph>
      <Paragraph>
        For faithful, cohesive translations that are a pleasure to read, please don’t hesitate to get in touch.
      </Paragraph>
    </React.Fragment>
  )
}
